import { useEffect, useState, useRef } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import "../../styles/ConfirmModal.css";

export const CustomConfirmationComponent = (props) => {
const [tableData, setTableData] = useState({});
const {fieldData, onConfirm, setIsDelete, Datadisplay, message} = props;
const buttonRef = useRef(null);

   useEffect(() => {
    const filteredDate = Object.fromEntries(
        Object.entries(fieldData)
        .filter(([key]) => Datadisplay.hasOwnProperty(key))
      )
      setTableData(filteredDate);
   }, [fieldData])

    const handleConfirm = () => {
        onConfirm();
        setIsDelete(false);
    }

    let displayInformation =
    Object.entries(tableData).map(([key, value]) => (
      <p style={{ color: "#000000" }} key={key}>
         <strong>{Datadisplay[key]}  :  </strong>{value !== null ? value : "No Data"}
      </p>
    ))

    const alertContent = (
        <div className="confirm-content">
      {displayInformation}
        </div>
      )

      const CustomUI = ({ onClose }) => {
          if (buttonRef.current) {
            buttonRef.current.focus();
          }
        return (
            <div className = "custom-confirm-alert">
              <div className="warning-symbol heading">&#9888;
              {message}</div>
              <div className="alert-content">{alertContent}</div>
              <div className="button-container">
              <button ref= {buttonRef} className= "cancel-btn" onClick={() => {onClose(); setIsDelete(false);}}>Cancel</button>
              <button ref= {buttonRef} className= "confirm-btn" onClick={() => {handleConfirm(); onClose(); }}>Yes</button>
              </div>
            </div>
        )
      }

      const options = {
        customUI: CustomUI
      }

      return (
        confirmAlert(options)
      )
}

